import { render, staticRenderFns } from "./DeprecateEventDialog.vue?vue&type=template&id=2e3f7136"
import script from "./DeprecateEventDialog.vue?vue&type=script&lang=js"
export * from "./DeprecateEventDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports